import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { UserEntity } from './user.entity';

@Index('fk_company__id', ['fkCompanyId'], {})
@Index('fk_user__id', ['fkUserId'], {})
@Entity('user_company')
export class UserCompanyEntity extends BaseEntity {
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('int', { name: 'fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@Column('varchar', { name: 'userExternalId', nullable: true, length: 64 })
	public userExternalId!: string | null;

	@Column('varchar', { name: 'userExternalIdType', nullable: true, length: 32 })
	public userExternalIdType!: string | null;

	@ManyToOne(() => UserEntity, (user) => user.userCompanies, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;

	@ManyToOne(() => CompanyEntity, (company) => company.userCompanies, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public fkCompany!: CompanyEntity;
}
